export default __webpack_public_path__ + "static/media/minus-box.74c20732.svg";